<template>
  <div class="row">
    <div class="col-md-12 bannerContainer">
      <article v-if="!loading" class="single-blog post-list">
        <hide-at breakpoint="'smallAndBelow'">
          <a @click.stop="$router.push({name: 'Vsa'})">
            <img
                :src="bannerSrc"
                alt="Vseslovenska akcija zbiranja zapisov"
                class="img-responsive w-100"
                style="cursor: pointer;"
            />
          </a>
        </hide-at>
        <show-at breakpoint="'small'">
          <a @click.stop="$router.push({name: 'Vsa'})">
            <img
                :src="bannerSrc"
                alt="Vseslovenska akcija zbiranja zapisov"
                class="img-responsive w-100"
                style="cursor: pointer;"
            />
          </a>
        </show-at>
      </article>
    </div>
  </div>
</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints';
import { db } from "@/main";

const defaultBanner = require('@/assets/images/promo/banner_naj_projekt.jpg');

export default {
  name: "BannerVsa",
  components: {
    hideAt,
    showAt
  },
  props: {},
  data() {
    return {
      bannerSrc: null,
      loading: true
    };
  },
  computed: {},
  async mounted() {
    try {
      const doc = await db.collection("page_content").doc("vsa").get();
      if (doc.exists && doc.data().bannerUrl) {
        this.bannerSrc = doc.data().bannerUrl;
      } else {
        this.bannerSrc = defaultBanner;
      }
    } catch (error) {
      console.error("Error loading banner:", error);
      this.bannerSrc = defaultBanner;
    }
    this.loading = false;
  },
  methods: {
    openLinkInNewTab(url) {
      setTimeout(() => {
        Object.assign(document.createElement("a"), {
          target: "_blank",
          href: url
        }).click();
      }, 10);
    }
  }
};
</script>
<style type="scss">
.bannerContainer {
  transition: all 0.3s ease;
  transform: scale(1.0);
  filter: saturate(1.0);
}

.bannerContainer:hover {
  cursor: pointer !important;
  transform: scale(1.03);
  filter: saturate(1.2);
}
</style>
